<div class="version flex max-h-12 min-h-8 grow flex-col items-center justify-center gap-1.5 py-1.5 text-[10px]">
  <div (click)="openReleaseNotes.emit(true)" class="flex flex-row items-center gap-2 hover:cursor-pointer hover:underline">
    @if (label()) {
      <span class="capitalize-first-letter">{{ label() }}</span>
    }
    <span>{{ computedBuildInfo()?.version }}</span>
    @if (showBuildNumber()) {
      <span>#{{ computedBuildInfo()?.buildNumber }}</span>
    }
  </div>
  @if (false && showChangelog() && changeLog()) {
    <div (click)="openChangelog.emit(true)" class="version">
      <span class="capitalize-first-letter">{{ 'Changelog' }}</span>
    </div>
  }
</div>
